/**
 * ストリーミング経路の NSIPS 録音前画面.
 *
 * 本体レンダリングは `@/apps/legacy/features/yakureki/screens/PreRecordingScreenContent`
 * を直接使用する (legacy への依存なし)。現状は content をそのまま forward する
 * 薄い wrapper だが、将来の streaming 固有拡張スロットとして独立 component を
 * 維持する:
 * - 録音中 (status=recording) の transcript 即時表示
 * - 話者分離候補の事前入力 UI
 * - PhraseSet プリセットの動的切替
 *
 * 拡張時は C' 化 (hook 物理分離 + Context dispatcher) と合わせて検討する.
 */
import { FC } from 'react'
import { PreRecordingScreenContent } from '@/apps/legacy/features/yakureki/screens/PreRecordingScreenContent'
import type { PreRecordingScreenProps } from '@/apps/legacy/features/yakureki/PreRecordingScreen'

export const StreamingNSIPSPreRecordingScreen: FC<PreRecordingScreenProps> = (
  props
) => {
  return <PreRecordingScreenContent {...props} />
}
